<template>
  <sliding-tabs :activeTab="activeNotificationTab" class="NOTIFICATION-TABS">
    <sliding-tabs-content
        v-for="(tab, index) in tabs"
        :key="tab.key"
        :name="tab.key"
        :titleProps="{
          title: tab.label,
          titleClass: (index ? 'text-capitalize p-x-2' : 'FIRST-TAB-TITLE p-x-2'),
          to: {
            name: 'dashboard::pro::notifications',
            params: { activeNotificationTab: tab.key }
          },
        }"
    />
  </sliding-tabs>
</template>

<script>
import { NOTIFICATION_TAB_NAMES } from '@/constants/notification-tab-names';
import SlidingTabs from '@/components/SlidingTabs';
import SlidingTabsContent from '@/components/SlidingTabs/SlidingTabsContent';

export default {
  NOTIFICATION_TAB_NAMES,
  name: 'notification-tabs',
  components: {
    SlidingTabs,
    SlidingTabsContent,
  },
  data () {
    return {
      tabs: [
        this.$options.NOTIFICATION_TAB_NAMES.updates,
        this.$options.NOTIFICATION_TAB_NAMES.notification,
      ],
    };
  },
  computed: {
    activeNotificationTab () {
      return this.$route.params.activeNotificationTab;
    },
  },
  watch: {
    activeNotificationTab (val) {
      this.$events.$emit(this.$events.NOTIFICATIONS_TAB_CHANGE, { tabName: val });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .NOTIFICATION-TABS {
    height: 42px;
    display: flex;
    flex: 0 0 auto !important;
    border-bottom: 1px solid $color-gray30;
  }

  /deep/ .FIRST-TAB-TITLE {
    text-transform: capitalize;
  }
</style>
